<template>
  <div class="event-condition">
    <span class="label">做过</span>
    <event-selector :width="134" v-model="event"> </event-selector
    ><zg-button
      v-if="!props.length"
      :disable="event === null"
      class="add-prop-btn"
      @click="onAddProp"
      icon="cicon-pagination-next"
      size="normal"
    ></zg-button>
    <template v-if="props.length">
      <template v-for="prop in props">
        <condition
          :propWidth="130"
          :event-id="event.event_id"
          :key="prop.id"
          :ref="'propCondition' + prop.id"
          v-model="prop.condition"
        ></condition>
        <i
          class="icon-delete-little1"
          :key="prop.id"
          @click="onDelProp(prop)"
        ></i
        ><br :key="prop.id" />
        <span :key="prop.id" class="blank"></span>
      </template>

      <zg-button
        class="btn-add"
        icon="icon-add-thin"
        v-show="props.length < propsMax"
        theme="border"
        @click="onAddProp"
      ></zg-button
      ><br />
      <span class="blank"></span>
    </template>
    <div
      :class="{
        'event-times-date': true,
        'event-times-date-has-prop': props.length
      }"
    >
      <div class="event-times">
        <zg-selector
          :store="numberOperatorList"
          v-model="timesOperate"
          class="ml5"
          :width="60"
          key-field="value"
          label-field="name"
        ></zg-selector>
        <zg-input class="ml5" v-model="times" :width="52"></zg-input>
        <span>次</span>
        <zg-tooltip content="触发次数为0等同于没有触发">
          <i class="icon-warn times-tip"></i>
        </zg-tooltip>
      </div>
      <div class="event-date">
        <span>在:</span>
        <zg-selector
          :store="dateOperatorList"
          :width="90"
          v-model="dateOperator"
          class="ml5"
          @change="onChangeOperator"
          key-field="value"
          label-field="name"
        >
          <!-- 非实时更新时间提示 -->
          <div slot="optionsHeader" class="options-header prop-update-time-tip">
            ＊用户新增数据为每日凌晨生成
          </div>
          <slot v-if="dateOperator">
            <span class="c-select-label">
              {{ dateOperator.name
              }}<span
                class="prop-symbol"
                v-if="dateOperator.value === 'join_time'"
                >{{ propSymbol }}</span
              >
            </span>
            <i class="c-select-arrow cicon-down"></i>
          </slot>
          <template slot-scope="scope">
            <span>{{ scope.data.name }}</span>
            <span v-if="scope.data.value === 'join_time'" class="prop-symbol">
              {{ propSymbol }}
            </span>
          </template>
        </zg-selector>
        <template v-if="['relative', 'join_time'].includes(dateOperator.value)">
          <zg-input v-model="date" class="ml5" :width="dateWidth"></zg-input>
          <span
            style="margin-left: 5px;margin-right: 5px"
            v-if="dateOperator.value === 'join_time'"
            >天内</span
          >
          <zg-tooltip
            v-if="dateOperator.value === 'join_time'"
            content="只计算近60天新增的用户"
          >
            <i class="icon-warn"></i>
          </zg-tooltip>
          <span
            style="margin-left: 5px"
            v-if="dateOperator.value === 'relative'"
            >天</span
          >
          <span v-if="dateOperator.value === 'relative' && date !== '0'" style="margin-left: 10px;">
            <c-checkbox v-model="todayDisable">不包含今天</c-checkbox>
          </span>
        </template>
        <el-date-picker
          v-else-if="dateOperator.value === 'absolute'"
          v-model="date"
          type="daterange"
          :editable="false"
          :clearable="false"
          range-separator="~"
          :picker-options="shortcuts"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </div>
    <div style="display: none">{{ output }}</div>
  </div>
</template>

<script>
import EventSelector from '../../components/eventSelector/index'
import { mapState } from 'vuex'
import Condition from './condition'
import { util } from '../../utils'
export default {
  name: 'eventCondition',
  components: {
    Condition,
    EventSelector
  },
  props: {
    value: null
  },
  data() {
    let data = {
      event: null,
      timesOperate: {
        value: '>='
      },
      times: '1',
      dateOperator: {
        value: 'relative'
      },
      date: '30',
      todayDisable: false,
      props: [],
      propsMax: 3,
      shortcuts: {
        disabledDate(time) {
          let end = new Date().setHours(0, 0, 0, 0)
          let current = time.getTime()
          return current > end
        }
      },
      propSymbol: '*'
    }
    if (this.value) {
      data.event = {
        event_id: this.value.eventId
      }
      data.timesOperate = {
        value: this.value.runTimes.operator
      }
      data.times = this.value.runTimes.values[0]
      data.dateOperator = {
        value: this.value.runPeriod.operator
      }
      switch (this.value.runPeriod.operator) {
        case 'unlimited_time':
          data.date = []
          break
        case 'join_time':
        case 'relative':
          data.date = this.value.runPeriod.values[0]
          data.todayDisable = this.value.runPeriod.values[1] === '1'
          break
        case 'absolute':
          data.date = [
            new Date(this.value.runPeriod.values[0]),
            new Date(this.value.runPeriod.values[1])
          ]
          break
      }
      this.value.attrs.forEach(prop => {
        let id = util.guid()
        data.props.push({
          id: id,
          condition: prop
        })
      })
    }
    return data
  },
  computed: {
    ...mapState({
      numberOperatorList(state) {
        return state.common.numberOperate
      },
      dateOperatorList(state) {
        return [
          { name: '任意时间', value: 'unlimited_time' },
          { name: '新增后', value: 'join_time' }
        ].concat(state.common.dateOperate)
      },
      currentApp(state) {
        return state.app.currentApp
      },
      dateWidth() {
        return 52
      }
    }),
    output() {
      if (!this.event) return
      let output = {
        attrs: [],
        eventId: this.event.event_id,
        runPeriod: {
          operator: this.dateOperator.value,
          values: this.getRunPeriodValues()
        },
        runTimes: {
          operator: this.timesOperate.value,
          values: [this.times]
        }
      }
      this.props.forEach(item => {
        if (item.condition) {
          output.attrs.push(item.condition)
        }
      })
      this.$emit('input', output)
      this.$emit('change', output)
      return output
    }
  },
  watch: {
    event() {
      this.timesOperate = {
        value: '>='
      }
      this.times = '1'
      this.dateOperator = {
        value: 'relative'
      }
      this.date = '30'
      this.props = []
    },
    date() {
      if (this.date === '0') {
        this.todayDisable = false
      }
    }
  },
  methods: {
    validate() {
      let result = {
        valid: true,
        errorMsg: ''
      }
      if (!this.event) {
        result.valid = false
        result.errorMsg = '没有选中事件'
        return result
      }
      if (util.isEmpty(this.times) || isNaN(this.times)) {
        result.valid = false
        result.errorMsg = '属性值错误或为空'
        return result
      }
      if (
        ['join_time', 'relative'].includes(this.dateOperator.value) &&
        (util.isEmpty(this.date) || isNaN(this.date))
      ) {
        result.valid = false
        result.errorMsg = '属性值错误或为空'
        return result
      }
      for (let i = 0; i < this.props.length; i++) {
        let item = this.props[i]
        let propConditions = this.$refs['propCondition' + item.id]
        for (let j = 0; j < propConditions.length; j++) {
          let propCondition = propConditions[j]
          let valid = propCondition.validate()
          if (!valid.valid) {
            result = valid
            return result
          }
        }
      }
      return result
    },
    getRunPeriodValues() {
      let values = []
      switch (this.dateOperator.value) {
        case 'unlimited_time':
          break
        case 'relative':
          values.push(this.date)
          if (this.currentApp.realTime) {
            values.push(this.todayDisable ? '1' : '0')
          } else {
            values.push('1')
          }
          break
        case 'join_time':
          values.push(this.date)
          values.push('1')
          break
        case 'absolute':
          values = this.date.map(time => util.dateFormat(time))
          break
        default:
          values = []
      }
      return values
    },
    onAddProp() {
      const id = util.guid()
      this.props.push({
        id,
        condition: null
      })
    },
    onDelProp(prop) {
      this.props.forEach((item, i) => {
        if (item.id === prop.id) {
          this.props.splice(i, 1)
        }
      })
    },
    onChangeOperator() {
      switch (this.dateOperator.value) {
        case 'relative':
          break
        case 'absolute': {
          let oneDate = 24 * 60 * 60 * 1000
          let end = new Date(new Date().getTime() - oneDate)
          let start = new Date(end - oneDate * 6)
          this.date = [start, end]
          break
        }
        case 'join_time':
          this.date = '3'
          break
        default:
          this.date = []
      }
      if (this.dateOperator.value === 'relative') {
        this.date = '30'
      }
    }
  }
}
</script>

<style lang="sass">
@import "./styles/eventCondition"
</style>
